import { render, staticRenderFns } from "./Create-Claim.vue?vue&type=template&id=531dc4bf&scoped=true"
import script from "./Create-Claim.vue?vue&type=script&lang=js"
export * from "./Create-Claim.vue?vue&type=script&lang=js"
import style0 from "./Create-Claim.vue?vue&type=style&index=0&id=531dc4bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531dc4bf",
  null
  
)

export default component.exports